import { UIContext, UIContextQuery } from "common/api/UIContext";

export interface User {
    email: string;
}

export interface Member {
    id: number;
    userIsMember: boolean;
    hasAccess: boolean;
    divisionId: number;
    clubId?: number;
}

export interface Email {
    email: string;
    isKnownEmail?: boolean;
    isLoggedWithThisEmail?: boolean;
}


export interface UIContextData {
    logedUser?: User;
    member?: Member;
    email?: Email;
}


class UIContextService {

    public getContext = (ctx: UIContext): UIContextData => {
        const result: UIContextData = {};

        result.logedUser = ctx.data['logedUser'] as User;
        result.member = ctx.data['member'] as Member;
        result.email = ctx.data['isKnownEmail'] as Email;

        return result;
    }

    public createContextQuery = (key: string, data: any): UIContextQuery => {

        const queryData: { [key: string]: any } = { [key]: JSON.stringify(data) };

        return { data: queryData };
    }

}

const uiContextService = new UIContextService();

export default uiContextService;